var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.473633,
    width: 41.6947,
    height: 41.6947,
    rx: 11.8004,
    fill: "#D9EBC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3093 11.6299H17.6171C16.3428 11.6299 15.3097 12.6629 15.3097 13.9373V28.7047C15.3097 29.9791 16.3428 31.0121 17.6171 31.0121H24.0778C25.3522 31.0121 26.3853 29.9791 26.3853 28.7047V13.9373C26.3853 12.6629 25.3522 11.6299 24.0779 11.6299H23.3856M18.3093 11.6299L18.7708 12.7836H22.9241L23.3856 11.6299M18.3093 11.6299H23.3856",
    stroke: "#81BC45",
    strokeWidth: 1.66133,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadApp);
export default __webpack_public_path__ + "static/media/download_app.29807bc8b6c70e2575d2a5336036c639.svg";
export { ForwardRef as ReactComponent };